import React from 'react';
import { Table, Tooltip, Button } from 'antd';
import { CommonTable } from 'common';
import { DocumentReference } from 'pages/Search/models';
import { useDispatch } from 'react-redux';
import { fetchExternalDetailsAsync, fetchDetailsAsync } from 'pages/Search';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAccessToken } from 'common/helpers';
import { InteractionStatus } from '@azure/msal-browser';

const { Column } = Table;
const RecordedDocumentReferences: React.FC<{
  items: DocumentReference[];
}> = ({ items }) => {
  const dispatch = useDispatch();
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const fetchExternalDetails = (record: DocumentReference) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(
            fetchExternalDetailsAsync(
              record.documentsIds,
              response.accessToken,
            ),
          );
      });
    }
  };

  const fetchDetails = (record: DocumentReference) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(
            fetchDetailsAsync(
              record.documentType,
              record.referenceBoro,
              record.documentId,
              response.accessToken,
            ),
          );
      });
    }
  };

  return (
    <CommonTable items={items}>
      <Column title="Document Type" dataIndex="reference_Instr" />
      <Column
        title="Reel"
        dataIndex="referenceReelFileNumber"
        render={(text: string, record: DocumentReference) =>
          record.referenceCrfn === '' ? text : ''
        }
      />
      <Column
        title="Page"
        dataIndex="referencePage"
        render={(text: string, record: DocumentReference) =>
          record.referenceCrfn === '' ? text : ''
        }
      />
      <Column title="CRFN" dataIndex="referenceCrfn" />
      <Column title="Doc ID" dataIndex="referenceDocumentID" />
      <Column title="Year" dataIndex="referenceReelYear" />
      <Column
        width="14rem"
        title="Document ID"
        dataIndex="documentsIds"
        render={(text: string, record: DocumentReference) => {
          return record.documentsIds && !!record.documentsIds.length ? (
            <>
              <Tooltip title="Document Viewer">
                <Button
                  type="link"
                  icon="paper-clip"
                  onClick={() => fetchExternalDetails(record)}
                >
                  {record.documentId}
                </Button>
              </Tooltip>
            </>
          ) : (
            <>{record.documentId}</>
          );
        }}
      />
      <Column
        title="Details"
        dataIndex="documentId"
        render={(text: string, record: DocumentReference, index: number) => {
          return (
            <Button
              type="link"
              size="small"
              icon="file-search"
              onClick={() => {
                record.documentType === 'federalTaxLiens'
                  ? console.log('Tech Debt')
                  : fetchDetails(record);
              }}
            >
              Details
            </Button>
          );
        }}
      />
    </CommonTable>
  );
};

export default React.memo(RecordedDocumentReferences);
